import { Outlet, useLocation } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { ReferralBanner } from "../ui";

export function Layout() {
  const location = useLocation();
  // Don't show banner on admin pages
  const isAdminPage = location.pathname.startsWith("/admin");

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Header />
      <main className="container py-6 flex-1">
        {!isAdminPage && <ReferralBanner />}
        <Outlet />
      </main>
      {!isAdminPage && <Footer />}
    </div>
  );
}
